import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { completeModalRecoil } from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType2 from '@/modal/ModalType2';

const CompleteModal = () => {
  return (
    <>
      <ModalType2>
        <span className="img-box">
          <img src="./img/modal_ico_check.png" alt="" />
        </span>
        <p>성공적으로 처리 되었습니다.</p>
        <div className="btn-box">
          <BS.Btn4Type4 type="button" onClick={() => window.location.reload()}>
            확인
          </BS.Btn4Type4>
        </div>
      </ModalType2>
    </>
  );
};

export default CompleteModal;
